import React, { useRef } from 'react';
import { useEditcleanerAppMutation, useGetWardsQuery } from './CleanerSlice';

function CleanerEdit({ refOpen, editData, setEditData }) {
    const refCloseDriver = useRef(null);
    const [editcleanerApp, { isLoading }] = useEditcleanerAppMutation();
    const {
        data: Wards
    } = useGetWardsQuery("getWards")

    // console.log("Wards", Wards?.entities);


    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const response = await editcleanerApp({
                cleaner_id: editData?.cleaner_id,
                name: editData?.name,
                number: editData?.number,
                ward_id_array: editData?.ward_id_array.split(" ")
            });
            refCloseDriver.current.click();
            setEditData({ name: "", number: "", ward_id_array: "" });
            console.log("response", response);

        } catch (e) {
            console.error("Error in cleaner edit", e);
        }
    };

    const handleCheckboxChange = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;

        // Get current string as array
        let currentArray = (editData.ward_id_array || "").split(" ").filter(v => v);

        if (checked) {
            if (!currentArray.includes(value)) {
                currentArray.push(value);
            }
        } else {
            currentArray = currentArray.filter(v => v !== value);
        }

        // Update the string
        setEditData((prev) => ({
            ...prev,
            ward_id_array: currentArray.join(" "),
        }));
    };

    return (
        <>
            <button
                ref={refOpen}
                type="button"
                className="btn d-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#depOffCanvas1"
                aria-controls="depOffCanvas1"
            ></button>

            <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="true"
                data-bs-backdrop="false"
                tabIndex="-1"
                id="depOffCanvas1"
                aria-labelledby="depOffCanvas1"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Cleaner</h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        ref={refCloseDriver}
                    ></button>
                </div>

                <div className="offcanvas-body">
                    <form className="row g-3">
                        <div className="col-md-12 text-left">
                            <label htmlFor="name" className="form-label font-weight-bold">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                value={editData?.name}
                                onChange={handleChange}
                                placeholder="Name"
                                autoComplete="off"
                                required
                            />
                        </div>

                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Number</label>
                            <input
                                type="text"
                                className="form-control"
                                id="number"
                                name="number"
                                value={editData?.number}
                                onChange={handleChange}
                                placeholder="Number"
                                autoComplete="off"
                                required
                            />
                        </div>


                        <div className="col-md-12 text-left">
                            <label className="form-label font-weight-bold">Ward</label>
                            <div>
                                {Wards?.ids?.reduce((acc, curr, index, array) => {
                                    if (index % 2 === 0) {
                                        const pair = array.slice(index, index + 2);
                                        acc.push(
                                            <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
                                                {pair.map((e) => (
                                                    <span key={e}>
                                                        <input
                                                            type="checkbox"
                                                            value={Wards?.entities[e]?.ward_id}
                                                            onChange={handleCheckboxChange}
                                                            checked={(editData.ward_id_array || "").split(" ").includes(Wards?.entities[e]?.ward_id)}
                                                        />
                                                        <label>{Wards?.entities[e]?.ward_number}</label>
                                                    </span>
                                                ))}
                                            </div>
                                        );
                                    }
                                    return acc;
                                }, [])}
                            </div>

                        </div>

                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-ff9b44 btn-block btn-round"
                                onClick={handleClick}
                            >
                                {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default CleanerEdit;
